import Global from "shared/icons/Global";
import { TeamDetailed } from "core/models/Tournament";
import userProfileImg from "assets/icons/userProfile.svg";

export default function TournamentChatTeam({
  team,
  teamIdToClass,
  isGroupChat,
}: {
  team: TeamDetailed;
  teamIdToClass: Record<string, string>;
  isGroupChat?: boolean;
}) {
  return (
    <div className={"chat-team-container"}>
      <div className={"chat-team-header"}>
        <div className={"chat-team-detail"}>
          <Global color="#ffffff" fontSize={24} />
          <h5
            className={`${
              teamIdToClass[team.teamId] ? teamIdToClass[team.teamId] : ""
            }`}
            style={{ color: `${teamIdToClass[team.teamId]}` }}
          >
            {team.teamName}
          </h5>
        </div>
        <div className={"chat-team-count"}>{team?.users?.length}</div>
      </div>

      {!isGroupChat && (
        <div className={"team-users"}>
          {team?.users?.map((user: any, index: number) => {
            const isLast = index === team?.users.length - 1;
            return (
              <div key={user.name} className={`${"team-user"}`}>
                <div className={"user-markings"}>
                  <div className={"line-top"} />
                  <div className={"line-horizontal"} />
                  <div className={`${!isLast ? "line-bottom" : ""}`} />
                </div>
                <div className={"profile-img-wrapper"}>
                  <img
                    src={user.profileImg || userProfileImg}
                    alt="profile img"
                    className={"profile-img"}
                    width={30}
                    height={30}
                  />
                  {/* {user.isOnline ? (
                    <OnlineIcon
                      className={'user-checker']}
                      // height={16.66} width={16.66}
                    />
                  ) : (
                    <OfflineIcon className={'user-checker']} />
                  )} */}
                </div>
                <h6 className="team-username">
                  {user?.name || user?.username}
                </h6>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
